import { PublicationService } from 'src/app/Service/publications.services';
import { SharedService } from './../Service/shared.service';
import { Global } from './../Service/global.service';
import { Component, OnInit, setTestabilityGetter } from '@angular/core';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    private global: Global,
    private sharedS: SharedService,
    private translate: TranslateService,
    private route: Router,
    private TitleS: Title,
    private publicationService: PublicationService
  ) {}

  MenuData = [];
  MenuDataPageTitle = [];
  MenuNiveau0 = [];
  langCode = '';
  topImages = [];
  videos = [];
 menuEspacePro = [];
 search = '';
  ngOnInit(): void {
    this.global.CurentLanguage.subscribe((lg) => {
      this.langCode = lg.code;
      this.sharedS.getMenu(lg.url).subscribe((data) => {
        this.MenuData = data['value'];
        this.MenuNiveau0 = this.getSousMenu(null);
      });
      this.sharedS.getMenuEspacePro(lg.url).subscribe(datas => {
        if(datas['value'].length > 0 ) {
          this.sharedS.getSubMenu(lg.url, datas['value'][0].Id).subscribe( menus => {
            this.menuEspacePro =_.orderBy( menus['value'],[function (o) {return +o.Ordre;}],['asc']);
           // console.log(this.menuEspacePro);
          })
        }
      });
      this.sharedS.getMenuPageTitle(lg.url).subscribe((data) => {
        this.MenuDataPageTitle = data['value'];
        this.setTitle(this.route.url.substr(1));
        this.global.navigationEnd.subscribe((data) => {
          $('#nav-principal').removeClass('show');
          this.setTitle(this.route.url.substr(1));
        });
      });
      // centre media
      let folderUrl = lg.relativeUrl + '/Phototheque';
      if(lg.relativeUrl === undefined) {
        folderUrl = lg.code ==='fr' ? '/fra/Phototheque' : (lg.code ==='en' ?  '/eng/Phototheque' : '/arb/Phototheque');
      }
     
      forkJoin([
        this.publicationService.getPhotothequeFolder(lg.url, folderUrl),
        this.publicationService.getVideoTheque(lg.url),
      ]).subscribe((datas) => {
        // Videotheque
        this.videos = [];
        datas[1]['value'].forEach((element) => {
          let i = 1;
          const obj = {
            title: element.Title,
            type: 'text/html',
            href: element.Url,
            youtube: element.YoutubeId,
            id: i,
          };
          i= i++;
          this.videos.push(obj);
        });
        // var videos = this.videos;
        // var checkExist1 = setInterval(() => {
        //   if (videos.length > 0) {
        //     clearInterval(checkExist1);
        //     var temoinIframe = document.getElementById('video1');
        //     if (temoinIframe !== null && temoinIframe !== undefined) {
        //       videos.forEach((element) => {
        //         var idFrame = 'video' + element.id;
        //         document.getElementById(idFrame).setAttribute("src",element.href);
        //       });
        //     }
        //   } else {
        //     clearInterval(checkExist1);
        //   }
        // },500);
        // Phototheque
        const requests = [];
        datas[0]['value'].forEach((element) => {
          requests.push(
            this.publicationService.getPhotothequeFolder(
              lg.url,
              element.FileDirRef + '/' + element.FileLeafRef
            )
          );
        });
        forkJoin(requests).subscribe((contents) => {
          
          var checkExist = setInterval(function () {
            if (
              document.getElementById('nav-principal') !== null &&
              document.getElementById('nav-principal') !== undefined
            ) {
              clearInterval(checkExist);
              $('#nav-principal').on('hidden.bs.dropdown', function () {
                $('.soumenumedia').removeClass('visible');
                $('#dropmedia a').removeClass('active');
                $('.col-megamenu:first-child').addClass('active');
              });

              $('.col-megamenu').on('mouseenter', function (params) {
                $('.col-megamenu').removeClass('active');
              });
              if ($('.megamenu').length > 0) {
                $('.megamenu ').on('click', function (e) {
                  e.stopPropagation();
                });
                $('.dropdown-item ').on('click', function (e) {
                  $('#dropmedia .dropdown-item').removeClass('active');
                  $('.dropdown-menu').removeClass('show');
                });
                $('.CloseMenu').on('click', function (e) {
                  $('.dropdown-menu').removeClass('show');
                });
              }

              if ($('.soumenumedia').length > 0) {
                $('#dropmedia .dropdown-item').on('mouseenter', function (e) {
                  e.preventDefault;
                  e.stopPropagation;
                  $(this).addClass('active');
                  $('.soumenumedia').addClass('visible');
                  if(lg.code !=='ar') {
                  
                    $('.slider-menu').slick({
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: false,
                      fade: true,
                      cssEase: 'linear',
                    });
                  } else {
                    $('.slider-menu').slick({
                      rtl: true,
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: false,
                      fade: true,
                      cssEase: 'linear',
                    });
                  }
                });
              }
            }
          }, 100); // check every 100ms
          const topImages = [];
          contents.forEach((content) => {
            if (content['value'].length > 2) {
              content['value'].forEach((item) => {
                if (item.FileLeafRef.toUpperCase().indexOf('.JPG') !== -1) {
                  const obj = {
                    image:
                      this.global._baseUrlRacine +
                      item.FileDirRef +
                      '/' +
                      item.FileLeafRef,
                    url: item.FileDirRef,
                    id: item.Id,
                    title:
                      item.FileDirRef.split('/')[
                        item.FileDirRef.split('/').length - 1
                      ],
                  };
                  topImages.push(obj);
                }
              });
            }
          });
          let i,
            j,
            chunk = 3;
          let temp = [];
          this.topImages = [];
          for (i = 0, j = topImages.length; i < j; i += chunk) {
            temp.push(topImages.slice(i, i + chunk));
          }
          let chunk2 = 2;
          for (i = 0, j = temp.length; i < j; i += chunk2) {
            this.topImages.push(temp.slice(i, i + chunk2));
          }
        
        });
      });
    });
  }
  translateto(language: string) {
    this.global.setCurentLanguge(language);
  }
  getSousMenu(id) {
    return _.orderBy(
      this.MenuData.filter((n) => n.ParentId == id),
      [
        function (o) {
          return +o.Ordre;
        },
      ],
      ['asc']
    );
  }
  setTitle(url) {
    let t = this.MenuDataPageTitle.filter((m) => m.ApplicationUrl == url);
    if (t.length) {
      this.TitleS.setTitle(t[0]['Title']);
    } else if (url.split('services/port').length > 1) {
      let s = url.split('/')[2];
      this.TitleS.setTitle(this.translate.instant('PortsPageTitle.' + s));
    } else {
      if (this.langCode === 'fr') {
        this.TitleS.setTitle('Accueil');
      } else if (this.langCode === 'en') {
        this.TitleS.setTitle('Home');
      } else {
        this.TitleS.setTitle('الرئيسية');
      }
    }
  }
  Search() {
    if(this.search !== null && this.search !== '' && this.search.length > 2) {
      const recherche = this.search
      this.search = '';
      this.route.navigate(['/recherche'],  { queryParams: {search: recherche} })
    } 
   
  
  }
  modal(code: string) {
    const urlVideo = 'https://www.youtube.com/embed/' + code
    $("#video1").attr('src', urlVideo + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
    $("#myModal1").modal("show");
    $('#myModal1').on('hide.bs.modal', (e) => {
      $("#video1").attr('src', "");
    })
  }
  iseirect(ApplicationUrl : string){
    return ApplicationUrl.indexOf('http') != -1
  }
}
